import React, { Component } from 'react';
import './InvoiceSheet.scss';
import {re_order, getTotals} from '../../helpers'
import moment from 'moment'
import request from 'superagent'
import LoaderButton from '../LoaderButton'
import Loader from '../Loader'
import {EmailHeader, EmailContent, EmailFooter} from './email'
import ProgressButton from 'react-progress-button'
import {Link} from 'react-router'
import * as _ from 'lodash'

class InvoiceSheet extends Component {

    constructor(props) {
        super(props);
        this.state = {
          email: null,
          iFrameHeight: 0,
          buttonState: ''
        }
        this._mail = this._mail.bind(this)
        this._resizeEmail = this._resizeEmail.bind(this)

    }

    componentDidMount() {

    }

    handleClick () {
     this.setState({buttonState: 'loading'})
     // make asynchronous call
     setTimeout(() => {
       this.setState({buttonState: 'success'})
     }, 3000)
   }

    getTables (dataset, type) {
      return dataset.map((item, index) => {
          const title = this.props.job.tabs[index]
          return (
            <div key={index}>

              <div className='row'>
                <div className='col-xs-6 '>
                  <strong><h4 className="">{title}</h4></strong>
                </div>
                <div className='col-xs-6 text-right'>
                  <strong><h4 className="m-0">Price</h4></strong>
                </div>
              </div>

              {item.map((doc, i) => {
                return (
                  <div className='row' key={i}>
                    <div className='col-xs-6 '>
                      {doc.quantity > 1 && <span>{doc.quantity}x</span>} {doc.label} - {doc.quantity > 1 && <span>£{doc.original} each</span>}
                    </div>
                    <div className='col-xs-6 text-right'>
                      <strong>£{doc.amount ? doc.amount : '0'}</strong>
                    </div>
                  </div>
                )
              })}
              <hr/>
            </div>
          )
      })
    }

    // componentDidMount () {
    //   // request.post('https://hen8qc89ci.execute-api.us-west-2.amazonaws.com/proquotes/generate-email').send(this.props.job).set('Accept', 'application/json').end((err, res) => {
    //   //   if (err) return console.log(err)
    //   //   this.setState({email: res.body})
    //   // })
    // }

    _mail (mail, email) {
      this.setState({buttonState: 'loading'})
      let data = {
          send_email: true,
          name: 'Dave',
          from_email: 'no-reply@proquotes.co.uk',
          subject: 'Test',
          to_email: email,
          response_subject: 'Audio Underground Response: ',
          response_body: mail
      }
      request.post('https://hen8qc89ci.execute-api.us-west-2.amazonaws.com/proquotes/email').send(data).set('Accept', 'application/json').end((err, res) => {
        if (err) return console.log(err)
        this.setState({buttonState: 'success'})
        this.props.notify(`${this.props.title} Sent`, 1, 'success')
      })
    }

    _resizeEmail (e) {
      this.setState({
        iFrameHeight: this.refs.iframe.contentWindow.document.body.scrollHeight
      })
    }

    render() {



        const { job } = this.props

        const details = _.get(this, 'props.details', {})
        const mainJob = _.get(this, 'props.mainJob', {})

        let mainTotals = []

        console.log(mainJob)

        const MailHeading = `<h2 style="margin: 0; color: #fff;">${mainJob.label}</h2>`

        const table = job.map((item, index) => {
          const it = item.items ? item.items : []
          let totals = []
          const itemsIn = it.map((doc, i) => {
            const quantity = doc.quantity ? doc.quantity : 1
            const sale = doc.sale ? doc.sale : 0
            const total = sale * quantity
            totals.push(total)
            return `<tr>
                      <td>${doc.name}</td>
                      <td class="">£${sale}</td>
                      <td class="" style="background: #ddd;">${quantity}</td>
                      <td class="aligncenter">£${total}</td>
                    </tr>`
          })
          const sectionTotals = totals.reduce((a, b) => Number(a) + Number(b), 0).toFixed(2)
          mainTotals.push(sectionTotals)
          return (`
            <table class="invoice">
              <tr>
                <td>
                  <table class="invoice-items" cellpadding="0" cellspacing="1">
                    <tr>
                      <th>Items1</th>
                      <th class="">Price</th>
                      <th class="">Quantity</th>
                      <th class="aligncenter">Total</th>
                    </tr>
                    ${itemsIn}
                    <tr>
                      <td class="" width="55%">&nbsp;</td>
                      <td class="">&nbsp;</td>
                      <td class="" style="background: #eee;">Total</td>
                      <td class="aligncenter" style="background: #eee;"><b>£${sectionTotals}</b></td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>`
          )
        })

        const discount = mainJob.discount ? mainJob.discount : 0
        const vat = mainJob.vat ? mainJob.vat : 0
        const subTotal = mainTotals.reduce((a, b) => Number(a) + Number(b), 0)
        let totalTal = mainTotals.reduce((a, b) => Number(a) + Number(b), 0)
        totalTal = (Number(totalTal) - ((Number(discount) / 100) * Number(totalTal)))
        totalTal = (Number(totalTal) + ((Number(vat) / 100) * Number(totalTal)))

        const tel = _.get(details, 'invoice_settings.number', '')
        const InvoiceDetails = `<div>
          <strong>${_.get(details, 'invoice_settings.business_name', '')}</strong><br/>
          ${_.get(details, 'invoice_settings.street_address', '')}<br/>
          ${_.get(details, 'invoice_settings.city', '')}<br/>
          ${_.get(details, 'invoice_settings.county', '')}<br/>
          ${_.get(details, 'invoice_settings.postcode', '')}<br/>
          <a href={tel:${tel}}>${tel}</a><br/>
        </div>`

        const ClientInvoiceDetails = `
          <b>${_.get(mainJob, 'address.client_name', '')}</b><br/>
          ${_.get(mainJob, 'address.address_1', '')}<br/>
          ${_.get(mainJob, 'address.city', '')}<br/>
          ${_.get(mainJob, 'address.postcode', '')}<br/>`



        const mailTop = `<table class="body-wrap">
          <tr>
            <td class="container" width="100%">
              <table class="main" width="100%" cellpadding="0" cellspacing="0" style="border-spacing: 0px;">
                <tr>
                  <td class="alert alert-warning" style="background: ${this.props.headerColor}; background-color: ${this.props.headerColor};">
                    <table width="100%">
                      <tr>
                        <td>
                          <table width="100%" class="invoice-items" cellpadding="30" cellspacing="0" style="border-spacing: 0px;">
                            <tr>
                              <th width="50%" class="alignleft">${MailHeading} <small>${moment(mainJob.start).format("Do MMMM YYYY")}</small></th>
                              <th width="50%" class="alignright"><h1 style="margin: 0; color: #fff;">${this.props.title}</h1></th>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>`

        const mailDetails = `<table class="invoice">
          <tr>
            <td>${InvoiceDetails}</td>
            <td class="alignright">${ClientInvoiceDetails}</td>
          </tr>
        </table>`

        const invoiceTotals = `<table class="invoice">
          <tr>
            <td>
              <table class="invoice-items no-border" cellpadding="10" cellspacing="1">
                <tr>
                  <td style="border: none;" class="" width="61%">&nbsp;</td>
                  <td style="border: none;" class="aligncenter">&nbsp;</td>
                  <td style="border: none;" class="" style="background: #eee;">Sub Total</td>
                  <td style="border: none;" class="aligncenter" style="background: #eee;"><b>£${subTotal.toFixed(2)}</b></td>
                </tr>
                <tr>
                  <td class="" width="60%">&nbsp;</td>
                  <td class="aligncenter">&nbsp;</td>
                  <td class="" style="background: #eee;">VAT</td>
                  <td class="aligncenter" style="background: #eee;"><b>${mainJob.vat && mainJob.vat}%</b></td>
                </tr>
                <tr>
                  <td class="" width="60%">&nbsp;</td>
                  <td class="aligncenter">&nbsp;</td>
                  <td class="" style="background: #eee;">Discount</td>
                  <td class="aligncenter" style="background: #eee;"><b>${mainJob.discount && mainJob.discount}%</b></td>
                </tr>
                <tr>
                  <td class="" width="60%">&nbsp;</td>
                  <td class="aligncenter">&nbsp;</td>
                  <td class="" style="background: #eee;">TOTAL</td>
                  <td class="aligncenter" style="background: #eee;"><b>£${totalTal.toFixed(2)}</b></td>
                </tr>
              </table>
            </td>
          </tr>
        </table>`

        const mailBottom = `<table class="invoice totals">
          <tr>
            <td>
              <table class="" width="100%" cellpadding="20" cellspacing="1" style="width: 100%;">
                <tr>
                  <td class="content-block aligncenter">
                    <a href="http://www.mailgun.com" class="btn-primary">Call Us</a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>`

        //mailBottom

        const Email = EmailHeader + mailTop + mailDetails + table + invoiceTotals + EmailFooter

        const email = _.get(mainJob, 'address.z_customer_email', '')

        // {!this.state.email &&
        //   <Loader color="#FF9F00" />
        // }

        return (
            <div className={`invoice-sheet m-b-lg`} id="divToPrint">

              


                <div>
                  <iframe ref='iframe' srcDoc={Email} style={{width:'100%', height:this.state.iFrameHeight, overflow:'auto', border: 'none'}} border="0" scrolling="no" onLoad={(e) => this._resizeEmail(e)} />



                <div className="text-center">
                  <div className='row'>
                    <br/>
                    Email will be sent to <br/>
                    {email}
                    <br/> <Link to={`/job/${this.props.jobId}/edit-view`}>Edit Email Address</Link>
                    <br/>
                  </div>
                  <div className='row m-t-lg'>
                    <div className='col-sm-4 col-sm-offset-4'>
                      <ProgressButton onClick={this._mail.bind(this, Email, email)} state={this.state.buttonState}>
                        Send Email &nbsp;<i className="icon-paperplane" />
                      </ProgressButton>
                    </div>
                  </div>
                </div>

                <br/>
                </div>


              </div>
        )
    }
}
// {mainJob && mainJob.address &&
//   <a onClick={this._mail(Email)}  className={`btn btn-lg btn-success send-btn  ${this.props.btnClass}`}>Send {this.props.title} &nbsp;<i className="icon-paperplane"></i></a>
// }


//
//       <div className='row'>
//         <div className='col-xs-12'>
//         <div className={`invoice-title ${this.props.class}`}>
//           <div className='row'>
//             <div className='col-sm-9'>
//               {mainJob && mainJob.label &&
//                 <h2 className='m-0'>{mainJob.label} - {this.props.title} <small>{moment(mainJob.start).format("Do MMMM YYYY")}</small></h2>
//               }
//             </div>
//             <div className='col-sm-3'>
//               {mainJob && mainJob.address &&
//                 <a href={`mailto:${mainJob.address.z_customer_email}?subject=${emailSubject}&body=${encodeURIComponent(emailBody)}`} className={`btn btn-lg btn-success send-btn btn-block pull-right ${this.props.btnClass}`}>Send {this.props.title} &nbsp;<i className="icon-paperplane"></i></a>
//               }

//             </div>
//           </div>
//         </div>
//         <hr/>
//         <div className='row'>
//           <div className='col-xs-6'>

//             <br/>
//             <address className='m-0 hidden'>
//               <strong>Order Date:</strong> March 7, 2014<br/><br/>
//             </address>
//           </div>
//           <div className='col-xs-6 text-right'>
//             <strong>Billed To:</strong><br/>
//
//
//             {mainJob && mainJob.address &&
//               <div>
//                 <strong>{mainJob.address.client_name}</strong><br/>
//                 {mainJob.address.address_1}<br/>
//                 {mainJob.address.city}<br/>
//               </div>
//             }
//
//             {details && details.user_details &&
//               <div className='hidden'>
//                 <p>{details.user_details.name}</p>
//                 <p>{details.user_details.number}</p>
//               </div>
//             }
//
//           </div>
//         </div>
//       </div>
//     </div>
//     <div className='row'>
//       <div className='col-md-12'>
//         <div className='panel panel-default'>
//           <div className='panel-heading'>
//             <h3 className='panel-title'><strong>Invoice Summary</strong></h3>
//           </div>
//           <div className='panel-body'>
//             <div className='table-responsive'>
//               <table className='table table-condensed'>
//                 {table}
//               </table>
//             </div>
//           </div>
//         </div>
//         <div className='text-'>
//           <br/>
//           <br/>
//           {mainJob && mainJob.discount && mainJob.discount !== '0' &&
//             <div>
//               <h2>Total: £{originalTotal}</h2>
//               <h4>Discount of {mainJob.discount}%</h4>
//             </div>
//           }
//           <h2 className='m-0'><strong>Total to Pay: £{100}</strong></h2>
//           <p>Please respond withing 7 days of receiving this {this.props.type}</p>
//           <br/>
//         </div>
//       </div>
//     </div>


//{outgoings}

export default InvoiceSheet



// WEBPACK FOOTER //
// ./src/views/components/InvoiceSheet/index.js